import { useEffect, useState } from "react";
import { Container, Grid, Button, Text, Table, ScrollArea, Modal, Image,Flex } from "@mantine/core";
import MantinePagination from "../../components/mantine/pagination";
import TitleComponent from "../../components/common/title";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getDrawingBysite } from "../../store/actions";
import { PlaceholderUi, useCustomMediaQuery } from "../../helpers/common";
import { useStateContext } from "../../Contexts/ContextProvider";
import { drawingDetailColumns } from "../../helpers/columns";
import MantineCloseButton from "../../components/mantine/closeButton";
import MantineTextInput from "../../components/mantine/textinput";
import { MantineGrid, MantineGridColumn } from "../../components/mantine/grid";

const DrawingDetail = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { category } = location.state || {};
  const { categoryId } = location.state || {};

  const { siteId } = useParams();
  const [searchValue, setSearchValue] = useState<any>('');
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [selectedImageUrl, setSelectedImageUrl] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { currentPrimaryColor } = useStateContext();
  const { isLargeScreenmin, isSmallScreen } = useCustomMediaQuery();
  const drawings = useSelector((state: any) => state.getsiteData.drawinglist);
  const totalCount = useSelector((state: any) => state.getsiteData.totalCount);
  useEffect(() => {
    dispatch(
      getDrawingBysite({
        siteId,
        categoryId,
        pageNumber,
        pageSize,
        sortColumn: "",
        sortDirection: "",
        searchKeyword: searchValue,
      })
    );
  }, [pageNumber, pageSize, siteId, categoryId,searchValue]);

  const handleDownload = async (url: string) => {
    try {
    const response = await fetch(url);
    const blob = await response.blob();
    const link = document.createElement("a");
    const urlObj = new URL(url);
    const fileName = urlObj.searchParams.get("fileName") || "downloaded_file";
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    } catch (error) {
    console.error("Download failed:", error);
    }
    };

  const handleView = async (url: string) => {
    const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
    const pdfExtension = ".pdf"; 
    const dwgExtension = ".dwg"; 
    const wordExtensions = [".doc", ".docx"];
    const excelExtensions = [".xls", ".xlsx"];   
    const fileNameMatch = url.match(/fileName=([^&]+)/i);
    const fileName = fileNameMatch ? decodeURIComponent(fileNameMatch[1]) : "";
    const extension = fileName.slice(fileName.lastIndexOf(".")).toLowerCase();
    const imagepath = getExtensionFromUrl(url);
    if (imageExtensions.includes(extension)|| imageExtensions.includes(imagepath)) {
      setSelectedImageUrl(url);
      setIsModalOpen(true);
    }
    else if (extension === pdfExtension) {
      const response = await fetch(url);
      const arrayBuffer = await response.arrayBuffer();
      const base64PDF = arrayBufferToBase64(arrayBuffer);
      
      let pdfWindow = window.open("");
      pdfWindow?.document.write(
        `<iframe width='100%' height='100%' src='data:application/pdf;base64, ${base64PDF}'></iframe>`
      );
    }
    else if (wordExtensions.includes(extension) || excelExtensions.includes(extension)) {
      const officeViewerUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(url)}`;
      window.open(officeViewerUrl, "_blank");
    }
    else if (extension===dwgExtension) {
      setSelectedImageUrl(url);
      setIsModalOpen(true);
    }
    else {
      window.open(url, "_blank");
    }
  };
  
  const getExtensionFromUrl = (url: string): string => {
    try {
      const urlObj = new URL(url);
      const pathname = urlObj.pathname; 
      const filename = pathname.split("/").pop() || ""; 
      return filename.slice(filename.lastIndexOf(".")).toLowerCase();
    } catch (err) {
      console.error("Invalid URL:", url);
      return "";
    }
  };
  const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
    const uint8Array = new Uint8Array(buffer);
    const binaryString = uint8Array.reduce((acc, byte) => acc + String.fromCharCode(byte), "");
    return window.btoa(binaryString); 
  };
  
  const handleCloseValue = () => {
    setSearchValue('');
  };

 const classButton = `w-fit text-sm font-thin ${isSmallScreen && 'w-full'}`
  return (
    <Container fluid style={{ width: "100%", padding: "1rem" }}>
      <TitleComponent title={`${category} - Lists`} />
      <Grid mt="lg">
        <div style={{ width: "100%", backgroundColor: "#fff", padding: "1rem 2rem", marginBottom: "1.5rem" }}>
          <MantineGrid className="py-1" grow={true}>
            <MantineGridColumn span={{ base: 12, md: 6, lg: 4 }}>
              <form
                onSubmit={(event: any) => {
                  event.preventDefault();
                  setPageNumber(1);
                }}
              >
                <Flex align="center" gap="sm">
                  <MantineTextInput
                    placeholder="Search by Title"
                    onChange={(event: any) => {
                      setSearchValue(event.currentTarget.value);
                    }}
                    value={searchValue}
                    rightSection={searchValue.length >= 1 && (
                      <MantineCloseButton onClick={handleCloseValue} />
                    )}
                    color={currentPrimaryColor}
                    classNames={{ input: `${PlaceholderUi}` }}
                    style={{ width: '350px' }}
                  />

                  <Button type="submit" color={currentPrimaryColor}
                    className={classButton}

                    onClick={() => setPageNumber(1)} >Search</Button>
                </Flex>
              </form>
            </MantineGridColumn>
          </MantineGrid>
        </div>
        <ScrollArea
          style={{
            width: "100%",
            maxHeight: "70vh",
            overflow: "auto",

            padding: "1rem",
            backgroundColor: "#fff",
          }}
        >
          {drawings?.length > 0 ? (
            <>
              <Table
                striped
                highlightOnHover
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 2,
                    backgroundColor: "#f8f9fa",
                  }}
                >
                  <tr>
                    {drawingDetailColumns.map((col: any) => (
                      <th
                        key={col.id}
                        style={{
                          textAlign: "center",
                          padding: "12px",
                          fontWeight: "bold",
                          borderBottom: "1px solid #e5e7eb",
                          color: "#333",
                        }}
                      >
                        {col.name}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody style={{ backgroundColor: "#f8f9fa" }}>
                  {drawings.map(
                    (
                      imageObj: { imageUrl: string | null; uploadFile: string | null; title: string; },
                      index: number
                    ) => {
                      const fileUrl = imageObj.imageUrl || imageObj.uploadFile || "";
                      let displayText = fileUrl;

                      if (imageObj.uploadFile) {
                        const urlParts =  new URL(imageObj.uploadFile);
                        const fileName = urlParts.searchParams.get("fileName");
                        if (fileName && fileName.length > 0) {
                          displayText = fileName;
                        }
                      }                    

                      return (
                        <tr
                          key={index}
                          style={{
                            borderBottom: index === drawings.length - 1 ? "none" : "1px solid #e5e7eb",
                          }}
                        >
                          <td style={{ textAlign: "center", padding: "12px" }}>
                            <Text size="sm" style={{ wordBreak: "break-word" }}>
                              {imageObj?.title}
                            </Text>

                          </td>
                          <td style={{ textAlign: "center", padding: "12px" }}>
                            <Text size="sm" style={{ wordBreak: "break-word" }}>
                              {displayText}
                            </Text>
                          </td>
                          <td style={{ textAlign: "center", padding: "12px" }}>
                            <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                              <Button variant="light" color="blue" onClick={() => handleView(fileUrl)}>
                                View
                              </Button>
                              <Button variant="light" color="blue" onClick={() => handleDownload(fileUrl)}>
                                Download
                              </Button>
                            </div>
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>

              </Table>
            </>
          ) : (
            <div style={{ textAlign: "center", marginTop: "1rem" }}>
              <Text color="dimmed">No files available.</Text>
            </div>
          )}
        </ScrollArea>


        {drawings.length > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "1rem",
              position: "sticky",
              bottom: 0,
              background: "#fff",
              padding: "10px",
              width: "100%",
            }}
          >
            <MantinePagination
              total={totalCount > 0 ? Math.ceil(totalCount / pageSize) : 1}
              onChange={(value: number) => setPageNumber(value)}
              withEdges
              value={pageNumber}
              size="md"
              color={currentPrimaryColor}
              className="m-auto pb-4"
              valueSelect={pageSize}
              onChangeSelect={(value: string) => {
                setPageSize(Number(value));
                setPageNumber(1);
              }}
            />
          </div>
        )}
      </Grid>


      <Modal
        opened={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Drawing Preview"
        size="lg"
      >
        {selectedImageUrl && (
          <Image
            src={selectedImageUrl}
            alt="Drawing Thumbnail"
            width="100%"
            fit="contain"
          />
        )}
      </Modal>
    </Container>
  );
};

export default DrawingDetail;
